export const keys = [
  { freq: 130.81, label: "C3", type: "natural" },
  { freq: 138.59, label: "C3#", type: "flat-sharp" },
  { freq: 146.83, label: "D3", type: "natural" },
  { freq: 155.56, label: "D3#", type: "flat-sharp" },
  { freq: 164.81, label: "E3", type: "natural" },
  { freq: 174.61, label: "F3", type: "natural" },
  { freq: 185, label: "F#3", type: "flat-sharp" },
  { freq: 196, label: "G3", type: "natural" },
  { freq: 207.65, label: "G3#", type: "flat-sharp" },
  { freq: 220, label: "A3", type: "natural" },
  { freq: 233.08, label: "A3#", type: "flat-sharp" },
  { freq: 246.94, label: "B3", type: "natural" },
  { freq: 261.63, label: "C4", type: "natural" },
  { freq: 277.18, label: "C4#", type: "flat-sharp" },
  { freq: 293.66, label: "D4", type: "natural" },
  { freq: 311.13, label: "D4#", type: "flat-sharp" },
  { freq: 329.63, label: "E4", type: "natural" },
  { freq: 349.23, label: "F4", type: "natural" },
  { freq: 369.99, label: "F#4", type: "flat-sharp" },
  { freq: 392, label: "G4", type: "natural" },
  { freq: 415.3, label: "G4#", type: "flat-sharp" },
  { freq: 440, label: "A4", type: "natural" },
  { freq: 466.16, label: "A4#", type: "flat-sharp" },
  { freq: 493.88, label: "B4", type: "natural" },
  { freq: 523.25, label: "C5", type: "natural" },
  { freq: 554.37, label: "C5#", type: "flat-sharp" },
  { freq: 587.33, label: "D5", type: "natural" },
  { freq: 622.25, label: "D5#", type: "flat-sharp" },
  { freq: 659.25, label: "E5", type: "natural" },
  { freq: 698.46, label: "F5", type: "natural" },
  { freq: 739.99, label: "F#5", type: "flat-sharp" },
  { freq: 783.99, label: "G5", type: "natural" },
  { freq: 830.61, label: "G5#", type: "flat-sharp" },
  { freq: 880, label: "A5", type: "natural" },
  { freq: 932.33, label: "A5#", type: "flat-sharp" },
  { freq: 987.77, label: "B5", type: "natural" },
  { freq: 1046.5, label: "C6", type: "natural" },
  { freq: 1108.73, label: "C6#", type: "flat-sharp" },
  { freq: 1174.66, label: "D6", type: "natural" },
  { freq: 1244.51, label: "D6#", type: "flat-sharp" },
  { freq: 1318.51, label: "E6", type: "natural" },
  { freq: 1396.91, label: "F6", type: "natural" },
  { freq: 1479.98, label: "F#6", type: "flat-sharp" },
  { freq: 1567.98, label: "G6", type: "natural" },
  { freq: 1661.22, label: "G6#", type: "flat-sharp" },
  { freq: 1760, label: "A6", type: "natural" },
  { freq: 1864.66, label: "A6#", type: "flat-sharp" },
  { freq: 1975.53, label: "B6", type: "natural" },
  { freq: 2093, label: "C7", type: "natural" },
  { freq: 2217.46, label: "C7#", type: "flat-sharp" },
  { freq: 2349.32, label: "D7", type: "natural" },
  { freq: 2489.02, label: "D7#", type: "flat-sharp" },
  { freq: 2637.02, label: "E7", type: "natural" },
  { freq: 2793.83, label: "F7", type: "natural" }
];
